if (!customElements.get("all-brands")) {
	customElements.define(
		"all-brands",
		class extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.searchInput = this.querySelector(".input");
				this.brandItems = this.querySelectorAll(".brands__item");
				this.brandLinks = this.querySelectorAll(".brands__link");

				this.hideEmptyCategories();
				this.searchInput.addEventListener(
					"input",
					this.handleSearch.bind(this)
				);
			}

			hideEmptyCategories() {
				this.brandItems.forEach((categoryItem) => {
					const brandList = categoryItem.querySelector(".brands__list");
					const brandLinks = brandList.querySelectorAll(".brands__link");

					if (brandLinks.length === 0) {
						categoryItem.classList.add("hidden");
					}
				});
			}

			handleSearch(event) {
				const searchTerm = event.target.value.toLowerCase().trim();

				if (searchTerm === "") {
					this.resetDisplay();
					return;
				}

				this.brandItems.forEach((categoryItem) => {
					let hasVisibleBrands = false;
					const brandList = categoryItem.querySelector(".brands__list");
					const brandLinks = brandList.querySelectorAll(".brands__link");

					brandLinks.forEach((link) => {
						const brandText = link.textContent.trim();
						const brandLower = brandText.toLowerCase();

						if (brandLower.includes(searchTerm)) {
							link.style.display = "";
							link.innerHTML = this.highlightText(brandText, searchTerm);
							hasVisibleBrands = true;
						} else {
							link.style.display = "none";
						}
					});

					if (hasVisibleBrands) {
						categoryItem.classList.remove("hidden");
					} else {
						categoryItem.classList.add("hidden");
					}
				});
			}

			highlightText(text, search) {
				const lowerText = text.toLowerCase();
				const index = lowerText.indexOf(search.toLowerCase());

				if (index === -1) return text;

				const before = text.slice(0, index);
				const match = text.slice(index, index + search.length);
				const after = text.slice(index + search.length);

				const highlighted = `${before}<strong>${match}</strong>${after}`;

				if (text === "FiiT by BESSEC") {
					return `<span class="text-transform--none">${highlighted}</span>`;
				}

				return highlighted;
			}

			resetDisplay() {
				this.brandItems.forEach((categoryItem) => {
					const brandList = categoryItem.querySelector(".brands__list");
					const brandLinks = brandList.querySelectorAll(".brands__link");

					if (brandLinks.length > 0) {
						categoryItem.classList.remove("hidden");
					}
				});

				this.brandLinks.forEach((link) => {
					link.style.display = "";
					const brandText = link.textContent.trim();

					if (brandText === "FiiT by BESSEC") {
						link.innerHTML = `<span class="text-transform--none">${brandText}</span>`;
					} else {
						link.textContent = brandText;
					}
				});
			}
		}
	);
}
